import krLocal from 'vant/lib/locale/lang/en-US'
import krJame from './languageJame/kr'
import krGaea from './languageGaea/kr'
import krAllen from './languageAllen/kr'
const kr = {
  300000: '새해 선물',
  300001: '2022 새해 선물',
  300002: 'SuperEx와 새해를 함께 보냅니다!',
  300003: 'SuperEx 회원님들 안녕하세요:<br>SuperEx가 새해를 맞을 때쯤 오픈하는 것을 축하하기 위하여<br>거래소에서는 1,000,000 USDT어치 새해 선물을 여러분한테 보내줍니다.<br>자세한 내용은 아래와 같습니다. ',
  300004: '이벤트 기간<br>캐나다 시간: 2022년01월01일00：00- 02월15일23：59',
  300005: '이벤트 1: 포스터 공유, 새해 선물 받기',
  300006: '이벤트 포스터를 1000명 이상인 telegram 암호화폐 단톡방으로 보내고 “SuperEx에서 푸짐한 선물을 주고 새해도 함께 보냅니다!”라는 문자를 붙입니다.or 이벤트 포스터를 트위터로 공유하고 “SuperEx에서 푸짐한 선물을 주고 새해도 함께 보냅니다!”라는 문자를 붙인 후에 상단 고정해야 합니다. 마지막에 이벤트 참여 사진을 캡처해서 고객센터로 보내면 5 ET를 받을 수 있습니다.（5 USDT어치）',
  300007: '이벤트 2: 사람 초대, VIP 되기',
  300008: '초대한 사람이 100USDT 이상을 넣어야 초대한 사람수로 인정이 됩니다.초대한 사람이 많을 수록 VIP등급도 높아집니다. 유효기간(30일)',
  300009: '이벤트3: 새 가입자 충전 서비스',
  300010: '이벤트 동안에 새 가입자가 충전한 순금액이 다음 구간에 도달해 거래가 완료되면 ET보너스를 받을 수 있습니다.(충전한 순금액이 이벤트 끝나기 전까지 USDT로 계산됩니다)',
  300011: '주의사항：',
  300012: '1.참여자마다 보너스를 한 번밖에 받을 수 없습니다. <br>2.모든 참여자들이 SuperEx 이용약관을 반드시 지키셔야 합니다.어기면 참여 자격이 취소됩니다. <br>3.SuperEx에서는 참여자에게 미리 알리지 않고 본 이베트 이용약관을 수정할 수 있습니다. <br>4.SuperEx에서는 규칙을 어기는 참여자에게 참여자격을 취소할 수 있고 관한 계정도 정지시킬 수 있습니다. <br>5.SuperEx에서는 이벤트에 최종 해석권이 있습니다.',
  300013: '바로 공유하기',
  300014: 'SuperEx팀',
  300015: '2022년01월01일',
  300016: 'SuperEx 포털사이트에 들어가서 더 보기：SuperEx.com',
  300017: '충전한 순금액（{coin}）',
  300018: '보너스（{coin}）',
  300019: '180일',
  300020: '충전한 순금액=총 입금액-총 출금액',
  300021: 'ET포지션 보유량',
  300022: 'Maker/Taker',
  300023: '초대한 사람수',
  300024: '증정한 유효기간',
  300025: '보너스 얻는  조건',
  300026: '힌트: 증정한 VIP 등급은 ET 포지션에 상관없습니다.',
  300027: '복사 성공',
  300028: '복사 실패',

  300029: '다운로드 SuperEx APP',
  300030: '어디 언제든 쉽게 거래하기',
  300031: 'SuperEx 계정 만들기',
  300032: '若您已有SuperEx账户，请先登录',
  300033: '이메일',
  300034: '핸드폰',
  300035: '핸드폰 번호',
  300036: '비밀번호',
  300037: '추천인 ID（선택 가능）',
  300038: '읽고 동의합니다',
  300039: 'SuperEx이용약관',
  300040: '저는 18살 이상이며 SuperEx이용약관에 동의합니다.',
  300041: '회원가입',
  300042: '보안 인증',
  300043: '지역 번호 선택',
  300044: '검색',
  300045: '핸드폰 번호를 입력하세요.',
  300046: '정확한 핸드폰 번호를 입력하세요.',
  300047: '이메일 주소를 입력하세요.',
  300048: '유효한 이메일 주소를 입력하세요.',
  300049: '비밀번호를 입력하세요.',
  300050: '최소 8문자, 대문자와 숫자 포함',
  300051: '이메일 인증번호',
  300052: '핸드폰 인증번호',
  300053: '구글/MS 인증번호',
  300054: '구글/ 마이크로소프트 인증',
  300055: '계정 안전을 위해 아래 인증을 하세요.',
  300056: '제출하기',
  300057: '6자리 인증번호를 핸드폰 {phone}로 보내드리겠습니다.',
  300058: '6자리 인증번호를 이메일 {email}로 보내드리겠습니다.',
  300059: 'SuperEx/Google/Microsoft의 인증 코드 6자리를 입력하세요.',
  300060: '6자리 인증번호를 입력하세요.',
  300061: '인증번호 보내기',
  300062: '{timeout}초 후 다시 보내기',
  300063: '언어',
  300064: '심사 중',
  300065: '영어 알파벳이나 정확한 문장 부호를 입력하세요',

  300066: '미션 센터',
  300067: '리베이트 이벤트 진행중',
  300068: '최대 <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> 획득!',
  300069: '초대하기',
  300070: '랭킹 리스트',
  300071: '해제 규칙',
  300072: '바로 ET를 수령합니다',
  300073: '리베이트 이벤트 진행중,최대 1BTC 획득',
  300074: '거래 완료,ET 획득',
  300075: '외 모든 미션을 완성하면 화이트 리스트를 얻을 수 있습니다. 거래소에서 화이트 리스트 사용자한테 랜덤으로 많은 ET  줍니다.',
  300076: '이벤트 데일리 순위',
  300077: '누적 순위',
  300078: '이용약관',
  300079: '내 보너스',

  300080: '동결량',
  300081: '해동량',
  300082: '잠금 해제 수량=수수료*잠금 해제 난이도/ET 가격',
  300083: '거래하기',
  300084: '순위',
  300085: '아이디',
  300086: '리베이트 수량',
  300087: '당일 순위는 당일 0시까지 계산되며 다음날에 보너스가 지급될 것이고 데이터에 오차가 있을 수 있으니 참고하시길 바랍니다.',
  300088: '보너스는 이베트 종료 후 3영업일 이내에 지급될 것이고 데이터에 오차가 있을 수 있으니 참고하시길 바랍니다.',
  300089: '더 보기',

  300090: '치우기',
  300091: '당신은 회이트 리스트 사용자입니다!',
  300092: '{type} 이이디를 입력하세요',
  300093: '정보 입력',
  300094: 'Twitter를 팔로우하기',
  300095: 'telegram 단톡방에 들어가기',
  300096: '첫 입금하기',
  300097: '첫 현물거래 하기',
  300098: '첫 선물거래 하기',
  300099: '친구를 추천해 회원가입하기',

  300100: '친구를 도와줘 거래하기',
  300101: '친구와 함께 더 많이 받기',
  300102: '입금하기',
  300103: '팔로우',
  300104: '받으러 가기',
  300105: '수령했음(횟수)',
  300106: '열리지 않음',
  300107: '카페 가입',
  300108: '데이터가 없음',
  300109: '완료',
  300110: '바로 SCS를 수령합니다. 친구를 추천하면 더 많은 ET를 받을 수 있습니다',
  300111: '취소',
  300112: '제출하기',
  300113: '이미 제출했습니다.',
  300114: '현재 미션이 없습니다',
  300115: '더 많은 미션을 기대해 주세요',
  300116: '앞으로 많은 이벤트가 있으니 많이 기대해 주세요',
  300117: 'Twitter 계정을 연동하면 받을 수 있음',
  300118: 'telegram 계정을 연동하면 받을 수 있음',
  300119: '포기',
  300120: 'SuperEx 회원가입하기',
  300121: '바로 회원가입',
  300122: '효력 없음',
  300123: 'White Paper',

  300124: '상자 보상',
  300125: '1,000USDT 디지털 블라인드 박스 보상, <em class="normal bold" style="color: #FFC72B">100%</em> 당첨!',
  300126: '규칙',
  300127: '상자 개봉',
  300128: '추첨 횟수',
  300129: '나의 남은 잔여',
  300130: '이미 오픈됨（총 금액USDT）',
  300131: '이벤트 보상',
  300132: '이벤트 설명',
  300133: '회원님의 초대 코드를 공유 하세요',
  300134: '미션 완료',
  300135: '친구를 초대하여 거래 작업을 등록하고 완료하세요.',
  300136: '상자 얻기',

  300137: '미션 달성 후 상자를 얻을 수 있습니다.',
  300138: '이벤트가 중료 되었습니다，다음 이벤트를 기다려 주세요！',
  300139: '이벤트 준비중입니다, 많은 기대 부탁드립니다！',
  300140: '이벤트 규칙',
  300141: '네',
  300142: '시간',
  300143: '검색',
  300144: '이메일 인증',
  300145: '친구 초대',
  300146: '잭오랜턴을 켜고 신나게 놀아요 <em class="normal" style="color: #FFC72B">할로윈</em>',
  300147: '<em class="normal" style="color: #FFC72B">{num}</em>일 연속 로그인 시 <em class="normal" style="color: #FFC72B">{amount} ET</em> 경품의 기회를 잡으세요.',
  300148: '수상자 목록',
  300149: '일일 체크인',

  300150: '{num}일 동안 로그인했습니다.',
  300151: '추첨',
  300152: '로그인',
  300153: '로그인',
  300154: '',
  300155: '',
  300156: '가입하다',
  300157: '계약금 공제 쿠폰 받기!',
  300158: 'VIP 업그레이드 성공!',
  300159: '복권 당첨의 기회를 잡으세요!',

  300160: '계약 수수료 쿠폰',
  300161: 'VIP 업그레이드',
  300162: '',
  300163: '<em class="normal" style="color: #FFC72B">{num}</em>번의 재계약 기회가 있습니다.',
  300164: '가입할 기회를 잡으세요',
  300165: '보완 가능',
  300166: '도움말',
  300167: '다시 서명했습니다.',
  300168: '재신청을 하지 않은 경우 당일 순충전금액이 {num} {symbol} 이상일 때 1회 재승인 기회를 얻을 수 있습니다.',
  300169: '로그인',

  300170: '재 체크인이 한도에 도달했습니다.',
  300171: '7일 연속 로그인 사용자의 당첨자 명단',
  300172: '다음 보상을 받으려면 계속 체크인하십시오.',
  300173: '받았다',
  300174: '{num} 하늘',
  300175: '쿠폰',
  300176: 'VIP 등급',
  300177: '추첨에 참여하세요',
  300178: '축하합니다!',
  300179: '로그인 성공',
  300180: '',
  300181: '대학',
  300182: '소식',
  300183: '데이터',
  300184: '공부하다',
  300185: '글로벌 암호화 산업의 주요 이벤트에 대한 통찰력 확보',
  300186: '전 세계 암호화 산업의 최신 이벤트를 빠르게 살펴보십시오.',
  300187: '블록체인, Web3, 암호화폐에 대한 포괄적인 이해',
  300188: '더 읽기',
  300189: '동영상',
  300190: '로딩중',
  300191: '로딩 완료',
  300192: '전체',
  300193: '아직 개최되지 않은 대회',
  300194: '제한된<em class="normal" style="color:#DBFF00">보너스</em> 에서 우승하기 위해 경쟁의 승자를 예측',
  300195: '활동 시간',
  300196: '투표 기록',
  300197: '그룹 경기',
  300198: '{num}그룹',
  300199: '상금 풀: {num}',
  300200: '지원하다',
  300201: '녹아웃',
  300202: '프로모션',
  300203: '남은 투표 마감',
  300204: '투표',
  300205: '지원 개수를 입력하세요',
  300206: '최소 퀴즈 수： {num} ET ',
  300207: '퀴즈 시간',
  300208: '팀을 맞춰봐',
  300209: '입력 수량',
  300210: '당첨금액',
  300211: '예선팀',
  300212: '일',
  300213: '시',
  300214: '분',
  300215: '초',
  300216: '상영',
  300217: '아직 이벤트가 시작되지 않았습니다',
  300218: '1/4 결승',
  300219: '확인',
  300220: '지지대수',
  300221: '잔고가 부족합니다',
  300222: '입금하기',
  300223: '퀴즈성공',
  300224: '1/8 결승',
  300225: '준결승',
  300226: '3위와4위 결승전',
  300227: '결승',
  300228: '이기다',
  300229: '잃다',
  300230: '총 상금 풀:{num} ET',
  300231: '더 많은 경기 보기',
  300232: '기타 장소',
  300233: '코인 종류',
  300234: '현재가',
  300235: '24h 등락률',
  300236: '초보자 안내',
  300237: '디저털 암호화폐 배우기 바로 시작합니다',
  300238: '글로벌운영',
  300239: '국경 없는 탈중앙화 커뮤니티 관리를 가지고 있습니다. 팀 탈중앙화는 SuperEx 발전의 최종 목표입니다.',

  300240: '안전하고 리스크 없음',
  300241: '탈중앙화 지갑인 SuperWallet을 가지고 개인키는 사용자 기기에 저장됩니다.코드 보안, 정치 등의 요인에 영향을 받지 않습니다.',
  300242: '등록없음&KYC ',
  300243: '지갑 허락을 한 후에 거래를 할 수 있습니다.  등록과 KYC가 없고 체인에서 거래할 수 있습니다. 바꿀 수 없고 투명합니다.',
  300244: '오픈 시스템 ',
  300245: '사용자는 Dapp 또는 스마트 컨트랙트와 상호작용하며 SuperWallet에 들어가서 Meta、Defi 、Nft 등 다양한 장면에 참여할 수 있습니다.',
  300246: '우주기금',
  300247: '우주 기금은 인류 우주 탐사에 사용되거나 인류 우주 탐사에 중대한 공헌을 한 기관이나 개인에 사용됩니다.',
  300248: '안전하고 간편한 디지털 화폐 시장',
  300249: 'SuperEx 앱을 다운로드하고 어디든 시장 동향을 잘 파악해 거래할 수 있습니다',

  300250: '추가 다운로드',
  300251: '당신의 모든 거래는 인류가 우주로 날아가는 연료입니다',
  300252: '회원가입',
  300253: 'iOS & Android<br>코드 스캔과 다운',
  300254: '인증기',
  300255: '인증기가 2단계 인증 코드를 생성합니다. 2단계 인증으로 SuperEx 계정을 더욱 안전하게 보호하세요.',
  300256: 'SuperEx 인증기',
  300257: 'Google 인증',
  300258: 'MS 인증',
  300259: '클라이언트 다운로드 (iPhone)',

  300260: '클라이언트 다운로드 (Android)',
  300261: '전세계에 제일 믿음직한 디저털 자산 거래소',
  300262: '소개',
  300263: '이용약관',
  300264: '개인정보처리방침',
  300265: '공지사항',
  300266: '공부',
  300267: '아카데미',
  300268: '현물 거래',
  300269: '선물거래',

  300270: '자주하는 질문',
  300271: '서비스',
  300272: '펀딩',
  300273: '거래 규칙',
  300274: '상장지원',
  300275: '수수료 리베이트',
  300276: '고객지원',
  300277: '고객센터',
  300278: '신청서 제출',
  300279: '비지니스 문의',

  300280: '미디어 콜라보',
  300281: '더 보기',
  300282: '다시 오신 것을 환영합니다',
  300283: '비밀번호를 잊으셨나요？',
  300284: '아직 계정이 없으신가요??',
  300285: 'APP 또는 컴퓨터로 이동하여 비밀번호를 재설정하세요.',
  300286: '내가 참조',

  300287: '확인',
  300288: '발표 될',
  300289: '수집하다',

  300290: '참여',
  300291: '환불',
  300292: '구매 규칙',
  300293: "클라우드 쇼핑 <span style='color: #ffc72b;'>좋은 것</span>",
  300294: '구매 참여',
  300295: '결과를 기다리는 중',
  300296: '제품 수령',
  300297: '잔액 충전',
  300298: '구매 내역',
  300299: '상품 목록',
  300300: '단일 참가비',
  300301: '{num} 사본이 판매되었으며 전체 {price} {currency}가 완료되면 구매가 종료됩니다',
  300302: '지금 가입하세요',
  300303: '계속 참여',
  300304: '구매할 사본 수를 선택하십시오',
  300305: "1세트는<span style='color: #fa4d56;'>{minPrice} {currency}</span>가 필요하며, 단일 아이템은 최대 까지 구매 가능합니다.",
  300306: '부품',
  300307: '당신은 {num} {currency}를 가지고 있으며, 더 많이 살수록 그것을 얻을 확률이 높아집니다',
  300308: '구입',
  300309: '놓친 기회',
  // 300309: '余额充值',
  300310: '축하해요',
  300311: '수령하기',
  300312: '다시 시도하십시오',
  300313: 'APP에서 충전 또는 P2P 입금 작업을 수행하십시오.',
  // 300314: '我知道了',
  300315: '제품을 수령하려면 APP의 고객 서비스에 문의하세요.',
  // 300316: '我知道了',
  300317: '로그인 회원가입',
  300318: '소비{num} {currency}',
  300319: '제품 설명',
  300320: '나의 참여',
  300321: '시간',
  300322: '참여 제품',
  300323: '구입한 사본 수',
  300324: '환불 금액',
  300325: '작업',
  300326: '수령하기',
  300327: '이미 계정이 있습니까?',
  300328: '로그인하기',
  300329: '인증 코드',
  300330: '지난 7일간의 기록만 표시',
  300331:"인증기",
  300332:'다운로드',
  300333:'1USDT로 1Bitcoin을 살 수 있습니다.',
  300334:"구매 가격",
  300335:"과거에 발표된",
  // 300336:"期次",
  300337:"규칙 보기",
  300338:"문제: [{num}단계]",
  300339:"구매 프로세스",
  300340:"성공적인 사용자 확보",
  300341:"발표 시간",
  300342:"공유하다",
  300343:"문제 [{num}]",
  300345:"다운로드",
  300346:"보여",
  300347:"참여하려면 코드를 스캔하세요",
  300348:"제품 수령",
  300349:"팁: 가상 통화 제품은 48시간 이내에 귀하의 계정으로 전송됩니다.",
  300350:"다른 제품은 고객센터로 문의주세요",
  300351:"확인하다",
  300352:"지금 등록하세요",
  300353:"등기",
  300354:'등록이 종료되었습니다',
  300355:'성공적으로 가입',
  300356:'앱 열기',
  300357:'{shop}을(를) 획득한 {user}님 축하합니다!',
  300358:'이벤트 센터',
  300359:'진행 중',
  300360:'곧 시작합니다',
  300361:'끝났다',
  300362:'지금 참여하세요',
  300363: '끝났다',
  300364: '수상자',
  300365: '당첨자는 곧 발표됩니다',
  300366: '통화',
  300367: '팔다',
  200368: '지불',
  300369: '받다',
  300370: '가져 오기',
  300371: '단일 거래 한도:',
  300372: '지불 방법',
  300373: '지불 방법',
  300374: '결제 채널',
  300375: '주문 내역',
  300376: '금액(거래 수수료 포함)',
  300377: '도착 시간',
  300378: '부인 성명',
  300379: '관련 내용을 이미 읽고 확인 했으며 동의합니다.',
  300380: "SuperEx 를 떠나 제3자로서 은행 카드 결제 기능을 제공하는 허가된 금융 기관인 <span>{name}</span>로 이동합니다. 사용 중 발생하는 모든 위험 사건은 <span>{name}</span>이 부담합니다. <span>{name}</span> 서비스를 이용하기 전, <a class='pointer' href={server}>서비스 이용약관</a>을 읽고 동의해 주시기 바랍니다.신용카드 입금과 관련하여 문의사항이 있으신 경우 <a class='pointer' href={Customer}>{name} 고객센터</a>로 문의하여 자세한 내용을 문의하시기 바랍니다.",
  300381: 'SuperEx 에서 암호화폐를 구매하는 방법은 무엇입니까?',
  300382: 'SuperEx 에서 암호화폐를 판매하는 방법?',
  300383: '암호화폐 주문하기',
  300384: '지불할 화폐 통화와 구매하려는 암호화폐를 선택하십시오. 지출하려는 금액을 입력합니다.',
  300385: '신원 확인',
  300386: 'SuperEx 및 결제 제공업체에서 KYC 인증을 완료하여 결제를 완료하세요.',
  300387: '주문 내역 확인',
  300388: '주문 상태를 확인하려면 입금 내역을 확인하세요.',
  300389: '자주하는 질문',
  300390: '1. 암호화폐 구매 시 어떤 결제 수단을 사용할 수 있나요?',
  300391: 'SuperEx 는 현재 VISA, Mastercard, Apple Pay, Google Pay 및 기타 결제 방법을 지원합니다. 지원되는 타사 서비스 제공업체에는 Mercuryo, alchemypay가 있습니다.',
  300392: '2. 어떤 암호화폐를 살 수 있나요?',
  300393: 'SuperEx 는 BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV, TRX 및 기타 주류 암호화폐를 지원합니다.',
  300394: '3. SuperEx 는 지원되는 타사 서비스 제공업체의 품질과 가격을 모니터링합니까?',
  300395: 'SuperEx 는 사용자에게 프로세스 중심의 서비스를 제공하기 위해 신뢰할 수 있는 업계 명성, 인기 및 보안을 갖춘 서비스 제공자 그룹을 신중하게 선택했습니다.',
  300396: '4. 암호화폐 구매 수수료는 얼마인가요?',
  300397: '타사 서비스 제공자에게 수수료 및 온체인 전송을 지불합니다. SuperEx 는 수수료를 부과하지 않습니다.',
  300398: '5. 결제 후 암호화폐를 받기까지 얼마나 걸리나요?',
  300399: '제3자 서비스 제공업체 플랫폼에서 결제를 완료하면 약 2~10분 내에 암호화폐가 SuperEx 현물 계정에 입금됩니다.',
  300400: '6. 구매 과정에서 문제가 발생하면 어떻게 해야 하나요?',
  300401: '거래 중 문제가 발생하면 고객 지원팀에 문의하십시오. 결제 완료 후에도 암호화폐를 받지 못한 경우, 제3자 서비스 제공업체에 문의하여 주문 내역을 확인하시기 바랍니다(일반적으로 이것이 가장 효율적인 방법입니다). 현재 지역의 IP 또는 일부 정책상의 이유로 수동 확인을 선택해야 합니다.',
  300402: "서용가능한 잔고",
  300403: '잔액 불충분',
  300404: '통화를 입력하세요',
  300405: '법정화폐를 입력하세요.',
  300406: '신원 확인을 완료하지 않았습니다.',
  300407: "거래 이용자의 계정 보안을 위해 먼저 본인 인증을 완료해주세요.",
  300408: '인증하기',
  300409: '아직 인증되지 않음',
  300410: '코인 선택',
  300411: '법정화폐 선택',
  300412: '모든 통화',
  300413: '모든 피아트',
  300414: '약 {time}분',
  300415: 'P2P 거래는 지갑 인증 사용자에게 일시적으로 공개되지 않습니다. P2P 거래를 수행하려면 SuperEx 계정으로 로그인하십시오.',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417: '구입',
  300418: '일련번호',

  300419: 'SuperEx 할로윈 활동',
  300420: '보너스를 얻기 위해 선물과 거래를 즐기기 위해 로그인하십시오!',
  300421:'유형',
  300422:'코인 보상',
  300423:'',
  300424:'',



  310000:'보상 총람',
  310001:'SCS 공중 투하',

  400000:'최초의 Web3 암호화 교환',
  400001:'우리와 함께 금융 세상을 만들어 보세요',
  400002:'당신의 모든 거래는 화성과 우주를 탐험하는 데 도움이 될 것입니다！',
  400003:'Superex 감동적인 리뷰',
  400004:'적극적인 참여 및 미소 공유: 우리의 활동 벽 이야기',
  400005:'언어 및 지역 선택',
  400006:'위험 0',
  400007:'KYC 없음',
  400008:'열려 있는',
  400009:'축적',
  400010:'메인넷 브라우저',
  400011:'테스트넷 브라우저',
  400012:'개발자 문서',
  400013:'기타',
  400014:'ET 존',
  400015:'판매 채널',

  400017: '휴대폰 번호 11자리 입력',

  ...krLocal,
  ...krJame,
  ...krGaea,
  ...krAllen
}
export default kr;



// WEBPACK FOOTER //
// ./src/i18n/langs/kr.js